const translations = {
  writeYourEmail: {
    tr: 'E-posta adresinizi giriniz',
    en: 'Write your email.',
    ar: 'أدخل عنوان البريد الإلكتروني الخاص بك',
  },
  writeYourPhone: {
    tr: 'Telefon numaranızı giriniz',
    en: 'Provide your phone number.',
    ar: 'يرجى إدخال رقم هاتفك',
  },
  writeYourMessage: {
    tr: 'Mesajınızı yazınız.',
    en: 'Write your message.',
    ar: 'اكتب رسالتك',
  },
  pleaseSelectAction: {
    tr: 'Yapmak istediğinizi lütfen aşağıdan seçiniz',
    en: 'Please select an action',
    ar: 'يرجى تحديد ما تريد القيام به',
  },
  conversationArchivedAutomaticly: {
    tr: 'Bu sohbet uzun süre cevap verilmediği için otomatik olarak tamamlanmıştır.',
    en: 'This chat has been archived automatically because you have not been active for a long time.',
    ar: 'اكتملت هذه الدردشة تلقائيًا لأنه لم يتم الرد عليها لفترة طويلة',
  },
  pleaseTypeValidMail: {
    tr: 'Lütfen geçerli bir eposta adresi girin.',
    en: 'Please enter a valid email address.',
    ar: 'يرجى إدخال عنوان بريد إلكتروني صالح',
  },
  pleaseTypeValidPhone: {
    tr: 'Lütfen geçerli bir telefon numarası girin',
    en: 'Please type a valid phone number.',
    ar: 'الرجاء إدخال رقم هاتف صحيح',
  },
  howCanIHelpYouType: {
    tr: 'Hoşgeldiniz! Size hangi konuda yardımcı olabilirim?',
    en: 'Welcome! How may I help you? You can select your chat reason from bottom.',
    ar: 'أهلا وسهلا بكم! كيف يمكنني مساعدتك؟',
  },
  howCanIHelpYou: {
    tr: 'Hoşgeldiniz! Size nasıl yardımcı olabilirim?',
    en: 'Welcome! How may I help you?',
    ar: 'أهلا وسهلا بكم! كيف يمكنني مساعدتك؟',
  },
  endConversation: {
    tr: 'Konuşmayı Bitir',
    en: 'Complete Conversation',
    ar: 'إنهاء المحادثة',
  },
  continueConversation: {
    tr: 'Konuşmaya Devam Et',
    en: 'Continue to chat',
    ar: 'مواصلة الحديث',
  },
  thereWasAnError: {
    tr: 'Bir hata oluştu.',
    en: 'There was an error.',
    ar: 'عذرا لقد حدث خطأ.',
  },
  selectSubject: {
    tr: 'Konu seçiniz.',
    en: 'Please select a subject.',
    ar: 'اختر الموضوع',
  },
};  

const getTranslate = (lang, word) => {
  if (translations[word][lang]) return translations[word][lang];

  // Default language is turkish
  return translations[word]['tr'];
};

export default getTranslate;


// WEBPACK FOOTER //
// ./src/utils/translate.js